import React from 'react';
import { Modal } from 'react-bootstrap';
import Icon from '../common/Icons';
import { ClinicalButton } from './ui';
import './RxPrescriptionStockWarningModal.css';

export default function RxPrescriptionStockWarningModal({
  show,
  onHide,
  onConfirm,
  medicationName = '',
  warning = null,
  busy = false
}) {
  if (!warning) return null;

  const isOut = warning.severity === 'out';
  const toneClass = isOut ? 'rx-stock-warn-modal--out' : 'rx-stock-warn-modal--low';

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={`rx-stock-warn-modal ${toneClass}`}
      aria-labelledby="rx-stock-warn-title"
    >
      <Modal.Header closeButton className="rx-stock-warn-modal__head">
        <Modal.Title id="rx-stock-warn-title" className="rx-stock-warn-modal__title">
          <span className="rx-stock-warn-modal__icon-wrap" aria-hidden>
            <Icon
              name={isOut ? 'exclamationTriangle' : 'infoCircle'}
              size={18}
              className="rx-stock-warn-modal__icon"
            />
          </span>
          <span className="rx-stock-warn-modal__title-text">
            {warning.title}
            <span className="rx-stock-warn-modal__badge">
              {isOut ? 'Rupture' : 'Alerte stock'}
            </span>
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="rx-stock-warn-modal__body">
        {medicationName ? (
          <p className="rx-stock-warn-modal__med">
            <span className="rx-stock-warn-modal__med-label">Médicament</span>
            <strong>{medicationName}</strong>
          </p>
        ) : null}
        <p className="rx-stock-warn-modal__message">{warning.message}</p>
        {warning.detail ? (
          <div className="rx-stock-warn-modal__detail">
            <span className="rx-stock-warn-modal__detail-label">Stock site</span>
            <span className="rx-stock-warn-modal__detail-value">{warning.detail}</span>
          </div>
        ) : null}
        <p className="rx-stock-warn-modal__hint">
          Vous pouvez ajouter quand même la ligne à l&apos;ordonnance (dispensation ou réapprovisionnement à
          prévoir).
        </p>
      </Modal.Body>

      <Modal.Footer className="rx-stock-warn-modal__foot">
        <ClinicalButton variant="ghost" size="sm" type="button" onClick={onHide} disabled={busy}>
          Annuler
        </ClinicalButton>
        <ClinicalButton
          variant={isOut ? 'secondary' : 'primary'}
          size="sm"
          type="button"
          className="rx-stock-warn-modal__confirm"
          onClick={onConfirm}
          disabled={busy}
        >
          Prescrire quand même
        </ClinicalButton>
      </Modal.Footer>
    </Modal>
  );
}
